import React from "react";
import {connect} from "react-redux";
import ArticleItem from "./ArticleItem";
import ArchiveLink from "./ArchiveLink";
import {getCurrentSectionIdBeingScrolled, getUrlTemporaryId} from "../../../../redux/selectors/navigation";
import {getSectionAnchorId} from "../../../../redux/selectors/sections"

/**
 * ouptut a section of articles
 * @param  {} props
 * @return {}
 */
const Section = (props) => {
    const {
        section,
        sectionIdBeingScrolled,
        sectionAnchor,
        temporaryId,
    } = props;

    return (
        <li className="nav-item">
            <ArchiveLink
                hash = {sectionAnchor}
                temporaryId = {temporaryId}
                className = {`section-title text-truncate ${section.id === sectionIdBeingScrolled ? "font-weight-bold" : ""}`}>
                    {section.name}
            </ArchiveLink>

            <ul className="nav flex-column nested-list">
                {section.giList.map((id, index) =>
                    (<ArticleItem itemId={id} key={id} />)
                )}
            </ul>

            <SubSections subSections = {section.subSections} temporaryId = {temporaryId} />
        </li>
    );
};

/**
 * output a list of subsections & corresponding articles in the left nav
 * @param {} props
 * @param {Array} props.subSections
 * @param {String|Number} props.temporaryId
 * @return {React Element | null}
 */
const SubSections = ({subSections, temporaryId}) => {
    if (subSections && subSections.length) {
        return (
            <React.Fragment>
                {subSections.map((subSection, index) => (
                    <React.Fragment key = {index}>
                        <ArchiveLink
                            temporaryId = {temporaryId}
                            hash = {`section_${subSection.groupingSectionId}`}
                            className = "text-truncate sub-section-title">
                                {subSection.name}
                        </ArchiveLink>

                        <ul className="nav flex-column nested-list" key={index}>
                            {subSection.giList.map((giId, index) => (
                                <ArticleItem itemId = {giId} key = {index} />
                            ))}
                        </ul>
                    </React.Fragment>
                ))}
            </React.Fragment>
        )
    } else {
        return null;
    }
}

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = (state, ownProps) => {
    const sectionId = ownProps.section.id;

    return {
        sectionIdBeingScrolled: getCurrentSectionIdBeingScrolled(state),
        sectionAnchor: getSectionAnchorId(state, sectionId),
        temporaryId: getUrlTemporaryId(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Section);
